import { Button, ButtonGroups } from "@nocios/presentation-kit";
import setCurrentPage from "src/Utils/setCurrentPage";

interface SkipsProps {
  backPageId: number;
  nextPageId: number;
}

const Skips = ({ backPageId, nextPageId }: SkipsProps) => {
  const handleNext = () => setCurrentPage(nextPageId);
  const handleBack = () => setCurrentPage(backPageId);

  return (
    <div>
      <ButtonGroups style={{ gap: "var(--width-8)" }}>
        <Button
          onClick={handleBack}
          style={{
            height: "auto",
            lineHeight: "var(--height-26)",
            padding: "0 var(--height-4)",
            fontSize: "var(--width-20)",
            gap: "var(--width-4)",
            borderRadius: "var(--width-2)",
            disflex: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          type="back"
          startIcon={{ icon: <IconBack /> }}
          label={"SKIP"}
        />
        <Button
          onClick={handleNext}
          style={{
            height: "auto",
            lineHeight: "var(--height-26)",
            padding: "0 var(--height-4)",
            fontSize: "var(--width-20)",
            gap: "var(--width-4)",
            borderRadius: "var(--width-2)",
            disflex: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          type="back"
          endIcon={{ icon: <IconNext /> }}
          label={"SKIP"}
        />
      </ButtonGroups>
    </div>
  );
};

const IconNext = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      style={{ width: "var(--width-18)", height: "var(--height-18)" }}
    >
      <path d="M4 15H2V1H4L10 7V1H14V15H10V9L4 15Z" fill="#fff" />
    </svg>
  );
};
const IconBack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      style={{ width: "var(--width-18)", height: "var(--height-18)", transform: "rotate(180deg)" }}
    >
      <path d="M4 15H2V1H4L10 7V1H14V15H10V9L4 15Z" fill="#fff" />
    </svg>
  );
};

export default Skips;
